var _circle, _circle2, _circle3, _circle4, _circle5, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "url(#paint0_linear_9869_109590)",
    fillOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 105,
    fill: "url(#paint1_linear_9869_109590)",
    fillOpacity: 0.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 85,
    fill: "url(#paint2_linear_9869_109590)",
    fillOpacity: 0.55
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 65,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 65,
    fill: "url(#paint3_radial_9869_109590)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 91C106.232 91 91 106.232 91 125C91 143.768 106.232 159 125 159C143.768 159 159 143.768 159 125C159 106.232 143.768 91 125 91ZM128.4 142H121.6V135.2H128.4V142ZM128.4 128.4H121.6V108H128.4V128.4Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9869_109590",
    x1: 125,
    y1: 0,
    x2: 125,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9869_109590",
    x1: 125,
    y1: 20,
    x2: 125,
    y2: 230,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#0073CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9869_109590",
    x1: 125,
    y1: 40,
    x2: 125,
    y2: 210,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#0073CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9869_109590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125 125) rotate(90) scale(65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073CF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationPoint);
export default __webpack_public_path__ + "static/media/exclamationPoint.acb28eb939bc8210a2ccfe3d8a3329b7.svg";
export { ForwardRef as ReactComponent };